export default {
  logo:"/img/logo.png",
  copy_right:"2021",
  version:"1.0.0"
}